import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2wk06yte9u9rt">
      <MetaPixel data-id="element-1" data-mp="2wiyv4mpflj91" />
      <CountdownBar data-id="element-2" data-mp="2wifc12o1ootf" />
      <main data-id="element-3" data-mp="2wi5nzkmk8rqd">
        <Hero data-id="element-4" data-mp="28ufoebm15ej2" />
        <StatsBar data-id="element-5" data-mp="28tw4wqgqei2x" />
        <Difference data-id="element-6" data-mp="28te2fc3h77mk" />
        <WhatsInside data-id="element-7" data-mp="28surifc8tji1" />
        <InsidePages data-id="element-8" data-mp="28s2x37udtrtc" />
        <Bonuses data-id="element-9" data-mp="23vkuadim43jn" />
        <Offer data-id="element-10" data-mp="23w4ey1znd61d" />
        <Guarantee data-id="element-11" data-mp="23ujmchww7x65" />
        <Testimonials data-id="element-12" data-mp="23v2tr4ox335x" />
        <Faq data-id="element-13" data-mp="3ijxpqrsp22kf" />
      </main>
      <Footer data-id="element-14" data-mp="3ikh5q2ysagvt" />
    </div>;
}